import { tx as translateInterfaceText } from '@/utils/i18n';
/**
 * Dados estáticos das integrações disponíveis
 * Contém informações sobre cada plataforma de integração
 */

import { integrationLogos } from '@/assets/integrations';

export interface IntegrationCardData {
  nameId: string;
  name: string;
  description: string;
  docsUrl: string;
  logo: string;
}

export interface IntegrationTab {
  type: string;
  label: string;
}

export const integrationsDataTabs: IntegrationTab[] = [
  { type: 'all', get label() { return translateInterfaceText("Todas"); } },
  { type: 'active', get label() { return translateInterfaceText("Ativada"); } },
  { type: 'inactive', get label() { return translateInterfaceText("Desativado"); } },
];

export const integrationsDataCards: IntegrationCardData[] = [
  {
    nameId: 'voxuy',
    name: 'Voxuy',
    get description() { return translateInterfaceText("Voxuy é uma plataforma de envio de SMS em massa."); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-fazer-a-integracao-com-a-vouxy-1cbdcjz',
    logo: integrationLogos['voxuy'],
  },
  {
    name: 'ActiveCampaign',
    nameId: 'activecampaign',
    get description() { return translateInterfaceText("Automatize emails personalizados, escale experiências únicas para clientes e transforme leads em receita."); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-fazer-a-integracao-com-a-active-campaign-zvprd2',
    logo: integrationLogos['activecampaign'],
  },
  {
    name: 'Leadlovers',
    nameId: 'leadlovers',
    get description() { return translateInterfaceText("Faça seu site, gere textos persuasivos em segundos, potencialize o relacionamento com seu público por Whatsapp, Instagram, e-mail, SMS e converta mais com a leadlovers!"); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-fazer-integracao-com-a-leadlovers-1wfns8k',
    logo: integrationLogos['leadlovers'],
  },
  {
    name: 'SellFlux',
    nameId: 'sellflux',
    get description() { return translateInterfaceText("Crie um Funil Poderoso que permite 1X1 baseado em eventos e disparos em massa multicanais. É tudo o que você precisa para mandar a mensagem certa na hora certa e maximizar as suas vendas!"); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-fazer-a-integracao-com-a-sellflux-w967o4',
    logo: integrationLogos['sellflux'],
  },
  {
    name: 'Zapp Rápido',
    nameId: 'zapp-rapido',
    get description() { return translateInterfaceText("Multiplique as suas vendas de forma automática com o chatbot que vende 24h por dia."); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-fazer-a-integracao-com-o-zapp-rapido-1hmwbsh',
    logo: integrationLogos['zapp-rapido'],
  },
  {
    name: 'SMS Funnel',
    nameId: 'smsfunnel',
    get description() { return translateInterfaceText("A solução perfeita para aumentar suas vendas! Com SMS Funnel você divulga seu produto ou serviço em tempo real para todo Brasil e todas as operadoras."); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-fazer-a-integracao-com-a-sms-funnel-18luvl9',
    logo: integrationLogos['smsfunnel'],
  },
  {
    name: 'BotConversa',
    nameId: 'bot-conversa',
    get description() { return translateInterfaceText("A Ferramenta Mais Fácil Para Criar Chatbots Sem Código Do Brasil. Agora você pode automatizar seu marketing, geração de lead, atendimento e muito mais com um robô."); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-fazer-a-integracao-com-o-botconversa-1jclb5y',
    logo: integrationLogos['bot-conversa'],
  },
  {
    name: 'Builderall',
    nameId: 'builderall',
    get description() { return translateInterfaceText("A Builderall oferece a plataforma mais completa de marketing e automação para você expandir seus negócios."); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-fazer-a-integracao-com-a-builderall-jw67cg',
    logo: integrationLogos['builderall'],
  },
  {
    name: 'Notificações Inteligentes',
    nameId: 'notificacoes-inteligentes',
    get description() { return translateInterfaceText("Automatize mensagens de texto, áudio e vídeo, recupere vendas perdidas de Pix e boletos, compras canceladas e carrinhos abandonados, crie chatbots, envie mensagens em massa, rastreie vendas e mais com nossas 271 funções."); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-fazer-a-integracao-com-a-notificacoes-inteligentes-k1hw41',
    logo: integrationLogos['notificacoes-inteligentes'],
  },
  {
    name: 'Meta Pixel',
    nameId: 'meta-pixel',
    get description() { return translateInterfaceText("O Meta Pixel é uma ferramenta de automação de marketing que ajuda a aumentar a conversão de vendas e a retenção de clientes."); },
    docsUrl:
      'https://help.hostvsl.com.br/pt-br/article/como-utilizar-o-pixel-1x6jzzi/?bust=1737316451992',
    logo: integrationLogos['meta-pixel'],
  },
];
